<template>
  <div class="preview-artwork" :class="{ compact }">
    <div v-if="art.textOnly">Text Only — {{ location.decoration_text }}</div>
    <template v-else>
      <div v-if="!compact">{{ art.name || 'Artwork' }}<span v-if="art.tape"> · Tape {{ art.tape }}</span></div>
      <img v-if="art.image && art.src && !failed" :src="art.src" :alt="art.name" @error="failed = true" />
      <div v-else-if="art.image" role="status">Preview unavailable</div>
      <div v-else class="file-card">File — {{ art.name || 'No previewable file' }}</div>
      <small v-if="art.reference && !compact">Reference artwork for new configuration</small>
    </template>
  </div>
</template>
<script>
import { previewArtwork } from '../../orderPreviewArtwork2'
export default {
  props: { compact: Boolean, location: { type: Object, required: true } },
  data: () => ({ failed: false }),
  computed: { art () { return previewArtwork(this.location, this.$apiAdress, localStorage.getItem('api_token')) } },
  watch: { 'art.src' () { this.failed = false } }
}
</script>
<style scoped>
.preview-artwork img { max-width: 100%; max-height: 120px; object-fit: contain; }
.preview-artwork.compact img { max-width: 90%; max-height: 100px; margin-top: 5px; }
.preview-artwork small { display: block; }
.file-card { padding: 12px; background: #f4f5f7; }
</style>
